import { DraftHandleValue, EditorState } from "draft-js";
import { isFocusInTheEndOfTheSourceText } from "../utils";

export const useHandleKeyCommand =
    () =>
    (command: string, editorState: EditorState): DraftHandleValue => {
        if (command === "delete" && isFocusInTheEndOfTheSourceText(editorState)) {
            return "handled";
        }

        return "not-handled";
    };
